export const ADMIN = 'ADMIN'